import { Alert, Stack } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Else } from "lib/@components/else"
import { useSelectFieldErrors } from "lib/@components/extended-select/hooks/use-select-field-errors"
import { If } from "lib/@components/switch"
import { FieldSelectorAlertError } from "slot-definitions"

export function MapFieldsAlert() {
    const { fieldErrors, hasFieldError } = useSelectFieldErrors()

    return (
        <If truthy={hasFieldError}>
            <Bound fieldErrors={fieldErrors}>
                <Alert severity="error" data-cy="map-fields-alert">
                    <Stack spacing={1}>{<FieldSelectorAlertError.Slot />}</Stack>
                </Alert>
            </Bound>
            <Else>
                <Alert severity="info" data-cy="map-fields-alert">
                    Any fields left blank will not be imported into the system.
                </Alert>
            </Else>
        </If>
    )
}
